import Api from '../Api';

import { url } from './config';
import { ComponentLevel } from './types';

const api = new Api<ComponentLevel>(url);

export default api;
